import { render } from "./AutoBook.component.vue?vue&type=template&id=f5d7a8fe&scoped=true"
import script from "./AutoBook.component.vue?vue&type=script&lang=js"
export * from "./AutoBook.component.vue?vue&type=script&lang=js"

import "./AutoBook.component.vue?vue&type=style&index=0&id=f5d7a8fe&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5d7a8fe"]])

export default __exports__
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QRadio,QBtn});
